import PropTypes from 'prop-types';

export const HIGHLIGHT_NORMAL = 'normal';
export const HIGHLIGHT_SUCCESS = 'success';
export const HIGHLIGHT_ERROR = 'error';

export const HIGHLIGHT_TYPES = [HIGHLIGHT_NORMAL, HIGHLIGHT_SUCCESS, HIGHLIGHT_ERROR];

export const calculateHighlightTrueFalse = (showCorrection, correct, answered, currentAnswer) => {
    if (!showCorrection) {
        return HIGHLIGHT_NORMAL;
    }

    if (answered && currentAnswer) {
        return correct ? HIGHLIGHT_SUCCESS : HIGHLIGHT_ERROR;
    }

    if (!answered && correct) {
        return HIGHLIGHT_SUCCESS;
    }

    return HIGHLIGHT_NORMAL;
};

export const calculateHighlight = (showCorrection, isCorrect, answered) => {
    if (!showCorrection || (!answered && !isCorrect)) {
        return HIGHLIGHT_NORMAL;
    }

    if (isCorrect) {
        return HIGHLIGHT_SUCCESS;
    }

    return HIGHLIGHT_ERROR;
};

export const exercisePropTypes = {
    exercise: PropTypes.shape({
        questions: PropTypes.arrayOf(
            PropTypes.shape({
                question: PropTypes.string,
                options: PropTypes.array,
            }),
        ),
    }).isRequired,
    onAnswer: PropTypes.func,
    /**
     * Exercises are free to use the best status topology.
     * */
    answers: PropTypes.any,
    showModal: PropTypes.func,
    correctionStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hintBoxIsOpen: PropTypes.bool,
    toggleHintBox: PropTypes.func,
    hasAttachments: PropTypes.shape({
        audio: PropTypes.bool,
        images: PropTypes.bool,
        sharedText: PropTypes.bool,
        video: PropTypes.bool,
        geogebra: PropTypes.bool,
    }),
    solution: PropTypes.bool,
};

export const exerciseDefaultProps = {
    hasAttachments: {
        audio: false,
        images: false,
        sharedText: false,
        video: false,
        geogebra: false,
    },
    answers: [],
};
